import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import PublicPlaylist from './public-playlist-model'
import {
  CreatePublicPlaylistAsync,
  DeletePublicPlaylistAsync,
  LoadPublicPlaylistsAsync,
} from './publicPlaylist-thunk'
const initialState: publicPlaylistSliceState = {
  publicPlaylist: [],
  selected_publicPlaylist: '',
  is_loading_publicPlaylist: false,
  is_creating_publicPlaylist: false,
  is_deleting_publicPlaylist: false,
}
export interface publicPlaylistSliceState {
  publicPlaylist: PublicPlaylist[]
  selected_publicPlaylist?: string
  is_loading_publicPlaylist: boolean
  is_creating_publicPlaylist: boolean
  is_deleting_publicPlaylist: boolean
}
export const publicPlaylistSlice = createSlice({
  name: 'publicPlaylist',
  initialState,
  reducers: {
    setSelectedpublicPlaylist: (state, action) => {
      state.selected_publicPlaylist = action.payload
    },
    clearStatepublicPlaylist: (state) => {
      state.publicPlaylist = []
      state.is_loading_publicPlaylist = false
      state.is_creating_publicPlaylist = false
      state.is_deleting_publicPlaylist = false
    },
    mergepublicPlaylist: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_publicPlaylist = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.publicPlaylist = merge(state.publicPlaylist, payload) as any
        }
      }
    },

    add_publicPlaylist: (state, action) => {
      if (action.payload) {
        state.publicPlaylist = [...state.publicPlaylist, action.payload]
      }
    },
    set_publicPlaylist: (state, action) => {
      let { key, value, id } = action.payload
      state.publicPlaylist = state.publicPlaylist.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadPublicPlaylistsAsync.pending, (state) => {
      state.is_loading_publicPlaylist = true
    })
    builder.addCase(LoadPublicPlaylistsAsync.fulfilled, (state, action) => {
      state.is_loading_publicPlaylist = false
      if (action.payload) {
        state.publicPlaylist = action.payload
      }
    })
    builder.addCase(LoadPublicPlaylistsAsync.rejected, (state) => {
      state.is_loading_publicPlaylist = false
    })
    builder.addCase(CreatePublicPlaylistAsync.pending, (state) => {
      state.is_creating_publicPlaylist = true
    })
    builder.addCase(CreatePublicPlaylistAsync.fulfilled, (state) => {
      state.is_creating_publicPlaylist = false
    })
    builder.addCase(CreatePublicPlaylistAsync.rejected, (state) => {
      state.is_creating_publicPlaylist = false
    })
    builder.addCase(DeletePublicPlaylistAsync.pending, (state) => {
      state.is_deleting_publicPlaylist = true
    })
    builder.addCase(DeletePublicPlaylistAsync.fulfilled, (state, action) => {
      state.is_deleting_publicPlaylist = false
      if (state.publicPlaylist) {
        state.publicPlaylist = state.publicPlaylist.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeletePublicPlaylistAsync.rejected, (state) => {
      state.is_deleting_publicPlaylist = false
    })
  },
})

export const {
  clearStatepublicPlaylist,
  setSelectedpublicPlaylist,
  set_publicPlaylist,
  mergepublicPlaylist,
  add_publicPlaylist,
} = publicPlaylistSlice.actions

export const get_publicPlaylist =
  (id?: string) =>
  (state: {
    publicPlaylist: {
      publicPlaylist: PublicPlaylist[]
    }
  }): PublicPlaylist | null => {
    let temp = state?.publicPlaylist?.publicPlaylist?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.publicPlaylist?.publicPlaylist[0] || null
  }
export const get_selected_publicPlaylist = (state: {
  publicPlaylist: publicPlaylistSliceState
}): PublicPlaylist | null => {
  let id = state?.publicPlaylist?.selected_publicPlaylist
  let temp = state?.publicPlaylist?.publicPlaylist?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_publicPlaylist = (state: {
  publicPlaylist: {
    publicPlaylist: PublicPlaylist[]
  }
}): PublicPlaylist[] => {
  let temp = state?.publicPlaylist?.publicPlaylist
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_publicPlaylist_busy = (state: {
  publicPlaylist: publicPlaylistSliceState
}) => {
  return (
    state?.publicPlaylist.is_deleting_publicPlaylist ||
    state?.publicPlaylist.is_loading_publicPlaylist ||
    state?.publicPlaylist.is_creating_publicPlaylist
  )
}
export const is_deleting_publicPlaylist_busy = (state: {
  publicPlaylist: publicPlaylistSliceState
}) => {
  return state?.publicPlaylist.is_deleting_publicPlaylist
}
export const is_loading_publicPlaylist_busy = (state: {
  publicPlaylist: publicPlaylistSliceState
}) => {
  return state?.publicPlaylist.is_loading_publicPlaylist
}
export const is_creating_publicPlaylist_busy = (state: {
  publicPlaylist: publicPlaylistSliceState
}) => {
  return state?.publicPlaylist.is_creating_publicPlaylist
}

export default publicPlaylistSlice.reducer
